import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("backup.databasePlan.store", { contractId: contractId }),
    request
  );
}

export function update(contractId, id, request) {
  return axios.put(
    api.path("backup.databasePlan.update", {
      contractId: contractId,
      id: id
    }),
    request
  );
}

export function list(contractId) {
  return axios.get(
    api.path("backup.databasePlan.index", { contractId: contractId })
  );
}

export function show(contractId, id) {
  return axios.get(
    api.path("backup.databasePlan.show", {
      contractId: contractId,
      id: id
    })
  );
}

export function remove(contractId, id, withBackups) {
  return axios.delete(
    api.path("backup.databasePlan.remove", {
      contractId: contractId,
      id: id
    }),
    {
      params: {
        withBackups: withBackups
      }
    }
  );
}

export function turnOn(contractId, id) {
  return axios.put(
    api.path("backup.databasePlan.turnOn", {
      contractId: contractId,
      id: id
    })
  );
}

export function turnOff(contractId, id) {
  return axios.put(
    api.path("backup.databasePlan.turnOff", {
      contractId: contractId,
      id: id
    })
  );
}
